import React from 'react';
import { Box } from 'rebass';

interface TabProps {
  selected?: boolean;
  title?: string;
}

export const Tab: React.FC<TabProps> = ({ selected, title }) => {
  const variant = selected ? 'tab.selected' : 'tab';
  return (
    <Box tx="tabs" variant={variant}>
      {title}
    </Box>
  );
};
